const chatsActionTypes = {
  addChat: 'chats/addChat',
};

export default chatsActionTypes;
